import { render, staticRenderFns } from "./MailTemplateForm.vue?vue&type=template&id=640e9c32&scoped=true&"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateForm.vue?vue&type=style&index=0&id=640e9c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e9c32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VSpacer,VTextField,VToolbar})
